export const toggleBodyTheme = newTheme => {
  newTheme = newTheme || "dark-theme";
  const oldClass = newTheme === "dark-theme" ? "light-theme" : "dark-theme";

  document.body.classList.remove(oldClass);
  document.body.classList.add(newTheme);
};
